var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3044_22567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0C9.91989 0 0.5 9.41989 0.5 21C0.5 32.5801 9.91989 42 21.5 42C33.0801 42 42.5 32.5785 42.5 21C42.5 9.42153 33.0801 0 21.5 0ZM21.5 38.7467C11.7157 38.7467 3.75328 30.7859 3.75328 21C3.75328 11.2141 11.7157 3.25328 21.5 3.25328C31.2843 3.25328 39.2467 11.2141 39.2467 21C39.2467 30.7859 31.2859 38.7467 21.5 38.7467Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6333 19.227H23.1267V12.7204C23.1267 11.8225 22.3996 11.0938 21.5 11.0938C20.6005 11.0938 19.8733 11.8225 19.8733 12.7204V19.227H13.3668C12.4672 19.227 11.7401 19.9557 11.7401 20.8537C11.7401 21.7516 12.4672 22.4803 13.3668 22.4803H19.8733V28.9869C19.8733 29.8848 20.6005 30.6136 21.5 30.6136C22.3996 30.6136 23.1267 29.8848 23.1267 28.9869V22.4803H29.6333C30.5328 22.4803 31.2599 21.7516 31.2599 20.8537C31.2599 19.9557 30.5328 19.227 29.6333 19.227Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3044_22567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.3f5ee2864927ccef6537f2113fbf76b2.svg";
export { ForwardRef as ReactComponent };